import { createContext, useContext } from 'react';

import { type GridContext as GridContextType } from '../types';

const GridContext = createContext({} as GridContextType);

export const useGridContext = () => useContext(GridContext);

export default GridContext;
